<script setup>
import { tv } from 'tailwind-variants';
import { useSegmentedControlsContext } from './useSegmendtedControls';

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click']);
const segmentedControlItemThemes = tv({
  base: 'text-sm flex items-center gap-1 px-2 py-1 rounded-lg cursor-pointer',
  variants: {
    active: {
      true: 'bg-brand-surface',
      false: 'text-brand-text-secondary hover:bg-brand-surface-secondary',
    },
  },
});
const { rootValue, onChange } = useSegmentedControlsContext();

function onClick() {
  emit('click');
  onChange(props.value);
}
</script>

<template>
  <button
    :class="segmentedControlItemThemes({ active: rootValue === props.value })"
    data-component="CsSegmentedControlItem"
    @click="onClick"
  >
    <slot />
  </button>
</template>
